import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '@components/layout';
import { RegisterForm } from '@components/registerForm';

const SignUp = () => {
  const intl = useIntl();
  const headerTitle = intl.formatMessage({ id: 'signUp.headerTitle', defaultMessage: 'Sign up for PLATFORM' });
  const headerDescription = intl.formatMessage({
    id: 'signUp.headerDescription',
    defaultMessage:
      'Sign up for PLATFORM on this page. Get access to limited-edition works, art world editorial content and more.',
  });

  return (
    <Layout title={headerTitle} defaultDescription={headerDescription}>
      <RegisterForm />
    </Layout>
  );
};

export default SignUp;
